import { get, post } from './common'
type ApiBaseResult = ApiTypes.ApiBaseResult

export namespace goods {
  // 获取课件学科分组
  export function getCourseMaterialRelation(): Promise<
    ApiBaseResult & {
      data: DataModels.goods.CourseMaterialRelation[]
    }
  > {
    return get('/goods/course_material_relation', {})
  }

  // 课件列表查询
  export function getCourseMaterialList(params: DataModels.goods.GoodsSearchParams): Promise<
    ApiBaseResult & {
      data: { total: number; list: DataModels.goods.CourseMaterialSimpleInfo[] }
    }
  > {
    return post('/goods/search', {}, { ...params })
  }

  // 课件详情
  export function getCourseMaterialDetail(
    goodsId: string,
    goodsType: DataModels.goods.GoodsType
  ): Promise<
    ApiBaseResult & {
      data: DataModels.goods.CourseMaterialDetail
    }
  > {
    return get('/goods/detail', { goodsId, goodsType })
  }

  // 相关课件推荐
  export function getRelatedRecommend(
    goodsId: string,
    goodsType: DataModels.goods.GoodsType
  ): Promise<
    ApiBaseResult & {
      data: DataModels.goods.CourseMaterialSimpleInfo[]
    }
  > {
    return get('/goods/related_recommend', { goodsId, goodsType })
  }

  // 获取课件价格信息
  export function getCourseMaterialPriceInfo(
    goodsId: string,
    goodsType: DataModels.goods.GoodsType,
    resourceId?: string
  ): Promise<
    ApiBaseResult & {
      data: DataModels.goods.CourseMaterialPriceInfo[]
    }
  > {
    return get('/goods/buy_recommend', { goodsId, goodsType, resourceId })
  }

  // 创建支付订单/goods/wx_pay_order
  export function createWxPayOrder(params: {
    // goodsId: string
    // goodsType: DataModels.goods.GoodsType
    planId: string
    materialId?: string
    chargeChannel: 'wx_h5' | 'alipay_h5'|'wx_jsapi'
  }): Promise<
    ApiBaseResult & {
      data: {
        codeUrl: string
        outTradeNo: string
        orderId:string
      }
    }
  > {
    return post('/order/create', {},{
      ...params,
      slugCode: sessionStorage.getItem('slug_code'),
    })
  }

  // 创建支付二维码
  export function createPayQrCode(params: {
    goodsId: string
    goodsType: DataModels.goods.GoodsType
    chargeChannel: 'wx_pub_qr' | 'alipay_qr'
  }): Promise<
    ApiBaseResult & {
      data: {
        codeUrl: string
        outTradeNo: string
      }
    }
  > {
    return get('/goods/wx_pay_order_qrcode', {
      ...params,
      utm: sessionStorage.getItem('utm') || undefined,
      kword: sessionStorage.getItem('kword') || undefined,
    })
  }

  // 创建JSAPI订单
  export function createJsapiPayOrder(params: {
   planId: string
   materialId?: string
   chargeChannel: 'wx_jsapi'
    // goodsType: DataModels.goods.GoodsType
  }): Promise<
    ApiBaseResult & {
      data: {
        jsapiParams: {
          appId: string
          nonceStr: string
          package: string
          paySign: string
          signType: string
          timeStamp: string
        }
        outTradeNo: string
      }
    }
  > {
    return post('/order/create', {},{ 
      ...params,      
      utm: sessionStorage.getItem('utm') || undefined,
      kword: sessionStorage.getItem('kword') || undefined, 
      slugCode: sessionStorage.getItem('slug_code'),
    })
  }

  // 查询订单状态/wx_pay_callback/verify
  export function verifyWxPayOrder(
    outTradeNo: string,
    // orderId: string
  ): Promise<ApiBaseResult & { data: { pay: boolean } }> {
    return get('/order/status', {outTradeNo})
  }

  // 是否购买了课件
  export function hasBuyGoods(
    goodsId: string,
    goodsType: DataModels.goods.GoodsType
  ): Promise<
    ApiBaseResult & {
      data: boolean | Array<DataModels.goods.MaterialInfo>
    }
  > {
    return get('/goods/has_buy_goods', { goodsId, goodsType })
  }

  // 下载记录
  export function addDownloadRecord(params: {
    goodsId: string
    goodsType: DataModels.goods.GoodsType
    materialId: string
  }): Promise<ApiBaseResult> {
    return post('/material/download_record', {}, params)
  }

  // 获取课件导航
  export function getCourseNav(): Promise<
    ApiBaseResult & { data: DataModels.goods.CourseMaterialRelation[] }
  > {
    return get('/course/nav', {})
  }

  // 获取课件单元信息
  export function getCourseUnit(data: { resourceId?: string; goodsId?: string }): Promise<
    ApiBaseResult & {
      data: {
        list: DataModels.goods.CourseMaterialUnit[]
        hasUnitChapter: boolean
      }
    }
  > {
    return get('/goods/chapter_list', data)
  }

  // 获取课件目录信息
  export function getGoodsNavInfo(
    goods_id: string,
    resource_id?: string
  ): Promise<ApiBaseResult & { data: DataModels.goods.GoodsNavInfo }> {
    return get('/goods/nav_info', { goods_id, resource_id })
  }

  // 获取课件套餐列表
  export function getGoodsPacketList(params: {
    goods_id: string
    resource_id: string
  }): Promise<ApiBaseResult & { data: DataModels.goods.Packet[] }> {
    return get('/goods/packet_list', params)
  }
}
